import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header className="text-blue-500 body-font bg-gray-900">
    <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
      Nick Radford
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
